import { AccountOrganization } from '../entity';
import { AccountOrganizationId } from '../value';
import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';

export abstract class IAccountOrganizationRepository extends IRepository<AccountOrganizationId, AccountOrganization> {
  abstract selectAll(builder: FirestoreQueryBuilder<AccountOrganization>): Observable<AccountOrganization>;
}
